var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportProblemModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 91.002,
    viewBox: "0 0 98 91.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "report_problem_modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kdkk83dv2a",
    x: 0,
    y: 2.997,
    width: 98,
    height: 88.005,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon base"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(9)",
    style: {
      fill: "none",
      opacity: 0.1
    },
    d: "M0 0h88v88H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#kdkk83dv2a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "triangle-exclamation-solid",
    d: "M40.034 32a6.238 6.238 0 0 1 5.391 3.094L79.177 92.6a6.247 6.247 0 0 1-5.391 9.407H6.282A6.247 6.247 0 0 1 .891 92.6l33.752-57.5a6.238 6.238 0 0 1 5.391-3.1zm0 20a3.741 3.741 0 0 0-3.75 3.75v17.5a3.75 3.75 0 0 0 7.5 0v-17.5a3.741 3.741 0 0 0-3.75-3.75zm5 35a5 5 0 1 0-5 5 5 5 0 0 0 5-5z",
    transform: "translate(8.96 -23)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportProblemModern);
export default __webpack_public_path__ + "static/media/report_problem_modern.dbd5f19c4fabee1d4470891a30c6481c.svg";
export { ForwardRef as ReactComponent };